import { FC, SVGProps } from 'react';

const CustomFieldSingleSelectIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#7A7A7A',
  size = 16,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.33325 11.9974H13.3337" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5.33325 7.99741H13.3337" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5.33325 3.99741H13.3337" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M2.67413 3.98758V4.03023M2.84697 3.99675C2.84697 4.09276 2.76908 4.17059 2.67307 4.17059C2.57706 4.17059 2.49927 4.09276 2.49927 3.99675C2.49927 3.90073 2.57706 3.82291 2.67307 3.82291C2.76908 3.82291 2.84697 3.90073 2.84697 3.99675Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.67413 8.07351V8.11618M2.84697 8.08264C2.84697 8.17871 2.76908 8.25651 2.67307 8.25651C2.57706 8.25651 2.49927 8.17871 2.49927 8.08264C2.49927 7.98664 2.57706 7.90884 2.67307 7.90884C2.76908 7.90884 2.84697 7.98664 2.84697 8.08264Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.67413 11.9874V12.0301M2.84697 11.9966C2.84697 12.0926 2.76908 12.1705 2.67307 12.1705C2.57706 12.1705 2.49927 12.0926 2.49927 11.9966C2.49927 11.9006 2.57706 11.8228 2.67307 11.8228C2.76908 11.8228 2.84697 11.9006 2.84697 11.9966Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CustomFieldSingleSelectIcon;
